// Formatting for times, dates and money. US month-day order, 12-hour clock.

/** 84 → "1:24" */
export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** 400 → "6h 40m", 25 → "25m" */
export function formatMinutes(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return h ? `${h}h ${m}m` : `${m}m`;
}

/** "Monday, October 5" */
export function formatDay(date: Date): string {
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Oct 5", "Sep 30" (three-letter months; some runtimes write "Sept") */
export function formatShortDate(date: Date): string {
  return `${MONTHS[date.getMonth()]} ${date.getDate()}`;
}

/** "6:42 PM" */
export function formatTime(date: Date): string {
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

/** US dollars with enough decimals for small AI costs: 0.0193 → "$0.0193", 4.2 → "$4.20", 0 → "$0" */
export function formatUsd(amount: number): string {
  if (amount === 0) return '$0';
  const digits = amount !== 0 && Math.abs(amount) < 0.1 ? 4 : 2;
  return `$${amount.toFixed(digits)}`;
}

/** "Good morning" / "Good afternoon" / "Good evening" */
export function greeting(date: Date = new Date()): string {
  const h = date.getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
}
